
import { Component, Mixins, Watch, Prop } from "vue-property-decorator";
import { FilterableMasterSelectableMixin } from "../../../system/selectors/mixins";
import { DomainRegistry } from "../../../../domain";
import { Profession } from "../../../../domain/user";

@Component({
})
export default class ProfessionsSelectableMixin extends Mixins(FilterableMasterSelectableMixin) {
  values: Profession[];

  @Prop({ default: null })
  defaultSelectedProfessionCodes: string[];

  @Watch("values")
  onValuesUpdated(newValue: Profession[], oldValue: Profession[]) {
    // 初回にデフォルト選択をセットする
    if (!oldValue && newValue) {
      if ((!this.editingSource || this.editingSource.length === 0)) {
        this.editingSource = newValue.filter(p => this.isDefaultSelectedProfession(p));
      }
    }
  }

  private isDefaultSelectedProfession(profession: Profession): boolean {
    if (!this.defaultSelectedProfessionCodes || this.defaultSelectedProfessionCodes.length === 0) { return false; }
    return this.defaultSelectedProfessionCodes.some(c => c === profession.id);
  }

  created() {
    const repository = DomainRegistry.user.getProfessionRepository();
    repository.getAllEntities()
      .then(e => { 
        this.values = this.sortByDefaultSelectedParameter(e);
      })
      .catch(e => {
        this.$error(
          "職種情報取得失敗",
          "職種情報を取得できませんでした。",
          e,
        );
      });
  }

  /**
   * 複数選択可能なコンポーネントに対してscrollIntoView()が使えないため、デフォルト指定されているオプションを先頭に持ってくる
   */
  private sortByDefaultSelectedParameter(professions: Profession[]): Profession[] {
    if (!professions) { return []; }
    const selectedOptions: Profession[] = [];
    const otherOptions: Profession[] = [];
    for (const profession of professions) {
      if (this.isDefaultSelectedProfession(profession)) {
        selectedOptions.push(profession);
      } else {
        otherOptions.push(profession);
      }
    }
    return selectedOptions.concat(otherOptions);
  }
}
